var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default_div"},[_c('img',{staticStyle:{"width":"262px","height":"266px"},attrs:{"src":require("../../static/talks/t_defaultIcon.png")}})])
}]

export { render, staticRenderFns }